import {
	BackgroundColors,
	BorderColors,
	BorderRadius,
	Button,
	ButtonSize,
	Flex,
	FlexChild,
	ForegroundColors,
	Typography,
} from "@abel-technologies-as/components";
import { useTranslation } from "react-i18next";
import { GenericModalFooterProps, ModalFooterVariant } from "./ModalFooter.types";

const getConfirmButtonColors = (variant: ModalFooterVariant) => {
	switch (variant) {
		case "danger":
			return {
				backgroundColor: BackgroundColors.ErrorSolid,
				borderColor: BackgroundColors.ErrorSolid,
			};
		case "brand":
			return {
				backgroundColor: BackgroundColors.BrandSolid,
				borderColor: BackgroundColors.BrandPrimary,
			};
		case "default":
		default:
			return {
				backgroundColor: BackgroundColors.BluePrimary,
				borderColor: BackgroundColors.BluePrimary,
			};
	}
};

export const GenericModalFooter = ({
	onCancel,
	onConfirm,
	cancelLabel,

	confirmLabel,
	variant = "default",
	size = ButtonSize.SMALL,
	disabled = false,
	fullWidth = false,
}: GenericModalFooterProps) => {
	const { t: tCommon } = useTranslation("common");

	const colors = getConfirmButtonColors(variant);
	const isMedium = size === ButtonSize.MEDIUM;
	const fontSize = isMedium ? "16px" : "14px";
	const lineHeight = isMedium ? "22px" : "20px";
	const marginLeft = isMedium ? "0" : "0 0 0 4px";

	const cancelButton = (
		<Button
			borderSize={"1px"}
			borderRadius={`${BorderRadius.MD}px`}
			size={size}
			onClick={onCancel}
			width={fullWidth ? "100%" : undefined}
			boxShadow={"0px 1px 2px 0px rgba(16, 24, 40, 0.05)"}
			borderColor={BorderColors.Primary}>
			<Typography
				margin={marginLeft}
				color={ForegroundColors.Secondary}
				fontSize={fontSize}
				fontWeight={600}
				lineHeight={lineHeight}
				fontFamily="Inter-SemiBold">
				{cancelLabel || tCommon("cancel")}
			</Typography>
		</Button>
	);

	const confirmButton = (
		<Button
			textColor="white"
			filled
			width={fullWidth ? "100%" : undefined}
			borderSize={"1px"}
			onClick={onConfirm}
			disabled={disabled}
			size={size}
			borderRadius={`${BorderRadius.MD}px`}
			backgroundColor={colors.backgroundColor}
			borderColor={colors.borderColor}>
			<Typography
				lineHeight={lineHeight}
				fontSize={fontSize}
				fontWeight={"600"}
				margin={isMedium ? "0" : "0 0 0 6px"}
				variant="p">
				{confirmLabel}
			</Typography>
		</Button>
	);

	return (
		<Flex
			margin="20px 0 0 0"
			gap="12px"
			width={fullWidth ? undefined : "100%"}
			justifyContent={fullWidth ? undefined : "flex-end"}>
			{fullWidth ? (
				<>
					<FlexChild flexBasis="1" flexGrow={1} flexShrink={1}>
						{cancelButton}
					</FlexChild>
					<FlexChild flexBasis="1" flexGrow={1} flexShrink={1}>
						{confirmButton}
					</FlexChild>
				</>
			) : (
				<>
					{cancelButton}
					{confirmButton}
				</>
			)}
		</Flex>
	);
};
